import { render, staticRenderFns } from "./Maximizer.vue?vue&type=template&id=1234d474&scoped=true&"
import script from "./Maximizer.vue?vue&type=script&lang=js&"
export * from "./Maximizer.vue?vue&type=script&lang=js&"
import style0 from "./Maximizer.vue?vue&type=style&index=0&id=1234d474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1234d474",
  null
  
)

export default component.exports